import { useState } from 'react';

export function useProvideBusy() {
  const [busy, setBusy] = useState(false);
  return { busy, setBusy };
}
